import { t } from '@lingui/core/macro';

export const translateTask = (name) =>
  ({
    'galaxy_ng.app.tasks.curate_all_synclist_repository': t`Curate all synclist repositories`,
    'galaxy_ng.app.tasks.curate_synclist_repository': t`Curate synclist repository`,
    'galaxy_ng.app.tasks.import_and_auto_approve': t`Import and auto approve`,
    'galaxy_ng.app.tasks.import_and_move_to_staging': t`Import and move to staging`,
    'galaxy_ng.app.tasks.promotion._remove_content_from_repository': t`Remove content from repository`,
    'galaxy_ng.app.tasks.publishing.import_and_auto_approve': t`Import and auto approve`,
    'galaxy_ng.app.tasks.synclist.curate_synclist_repository_batch': t`Curate synclist repository batch`,
    'pulp_ansible.app.tasks.collections.collection_sync': t`Collections sync`,
    'pulp_ansible.app.tasks.collections.import_collection': t`Import collection`,
    'pulp_ansible.app.tasks.collections.sync': t`Collections sync`,
    'pulp_ansible.app.tasks.collections.update_collection_remote': t`Update collection remote`,
    'pulp_ansible.app.tasks.copy.copy_content': t`Copy content`,
    'pulp_ansible.app.tasks.roles.synchronize': t`Roles synchronize`,
    'pulp_container.app.tasks.build_image_from_containerfile': t`Build image from Containerfile`,
    'pulp_container.app.tasks.general_multi_delete': t`General multi delete`,
    'pulp_container.app.tasks.recursive_add_content': t`Recursive add content`,
    'pulp_container.app.tasks.recursive_remove_content': t`Recursive remove content`,
    'pulp_container.app.tasks.synchronize': t`Synchronize`,
    'pulp_container.app.tasks.tag_image': t`Tag image`,
    'pulp_container.app.tasks.untag_image': t`Untag image`,
    'pulpcore.app.tasks.export.pulp_export': t`Pulp export`,
    'pulpcore.app.tasks.pulp_import': t`Pulp import`,
    'pulpcore.app.tasks.repository.add_and_remove': t`Add and remove repository`,
    'pulpcore.app.tasks.repository.delete_version': t`Delete repository version`,
    'pulpcore.app.tasks.repository.repair_version': t`Repair repository version`,
    'pulpcore.app.tasks.upload.commit': t`Upload commit`,
    'pulpcore.plugin.tasking.add_and_remove': t`Add or remove`,
    'pulpcore.tasking.tasks.base.general_create': t`General create`,
    'pulpcore.tasking.tasks.base.general_delete': t`General delete`,
    'pulpcore.tasking.tasks.base.general_update': t`General update`,
    'pulpcore.tasking.tasks.import_repository_version': t`Import repository version`,
    'pulpcore.tasking.tasks.orphan_cleanup': t`Orphan cleanup`,
    'pulpcore.tasking.tasks.repair_all_artifacts': t`Repair all artifacts`,
  })[name] || name;
